"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getAvailablityLabel;
exports.ENDLESS_DATE = void 0;

var _dayjs = _interopRequireDefault(require("dayjs"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var ENDLESS_DATE = '9999-12-31T00:00:00Z';
exports.ENDLESS_DATE = ENDLESS_DATE;

function getAvailablityLabel(bookablePeriods, T, formatDate) {
  if (!bookablePeriods.length) {
    return T('Unavailable');
  }

  var startDate = bookablePeriods[0].from;
  var endDate = bookablePeriods[0].to;
  var start = formatDate('D MMM YYYY', startDate);
  var end = formatDate('D MMM YYYY', endDate);

  if ((0, _dayjs["default"])().isAfter(startDate) && (0, _dayjs["default"])().isBefore(endDate)) {
    start = T('Now');
  }

  if ((0, _dayjs["default"])(endDate).isSame(ENDLESS_DATE)) {
    end = T('Unlimited');
  }

  return start + " - " + end;
}